import type { InjectionKey, Ref } from "vue";

import type { ChartIndex } from "shared/modules/Charts/types/chartSettings";
import type { InstantInsightsReport } from "shared/resources";
import type { Nullable } from "shared/types";

export const SelectedDashboardSymbol = Symbol(
  "SelectedDashboard"
) as InjectionKey<Ref<Nullable<InstantInsightsReport>>>;

export const DefaultChartsSymbol = Symbol("DefaultCharts") as InjectionKey<
  Ref<ChartIndex>
>;
export const IsPublicInsightsSymbol = Symbol(
  "isPublicInsights"
) as InjectionKey<Nullable<boolean>>;

export const PublicAccessKeySymbol = Symbol(
  "publicAccessKey"
) as InjectionKey<string>;
